/**
 * This file allows to use store inside redux modules without introducing circular dependencies.
 */
let storeInstance;

export const getStore = () => storeInstance;
export const setStore = (store) => {
  storeInstance = store;
};
